import { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import ReaderModal from "./ReaderModal";
import { BorderBottom } from "react-bootstrap-icons";
import {Modal, Form} from "react-bootstrap";

const CheckpointInline = (props) => {
    const [selectedReader, setSelectedReader] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [formErrors, setFormErrors] = useState({})

    const [showAssignModal, setShowAssignModal] = useState(false);
    const [selectedCheckpoint, setSelectedCheckpoint] = useState(null);
    const [selectedReaderId, setSelectedReaderId] = useState("");
    const [readers, setReaders] = useState([]);

    const openModal = (index) => {
        setSelectedReader(props.checkpoints[index].reader);
        setShowModal(true)
    };

    const openReaderConfigModal = (index) => {
        setSelectedReader(props.checkpoints[index].reader);
        setShowModal(true);
    };

    const closeModal = () => { setShowModal(false); setSelectedReader(null); };

    const handleChangeReader = (e) => {
        const { name, value, type, checked } = e.target;
        let newValue = type === 'checkbox' ? checked : value;
        if (name === "config_report_every_n_tags") {
            if (newValue === "")
                newValue = null;
        }
        setSelectedReader(prevSelected => ({ ...prevSelected, [name]: newValue }));
        setFormErrors(prevFormErrors => ({ ...prevFormErrors, [name]: null }));
    }

    useEffect(() => {
        axiosInstance.get("/readers/")
            .then(res => setReaders(res.data))
            .catch(err => console.log(err));
    }, []);

    const openAssignModal = (index) => {
        const checkpoint = props.checkpoints[index];
        setSelectedCheckpoint(checkpoint);
        setSelectedReaderId(checkpoint.reader?.id || "");
        setShowAssignModal(true);
    };

    const closeAssignModal = () => {
        setShowAssignModal(false);
        setSelectedCheckpoint(null);
        setSelectedReaderId("");
    };

    const handleAssignReader = (e) => {
        e.preventDefault();

        // CAS 1 : ASSIGNATION
        if (selectedReaderId) {
            axiosInstance.patch(`/readers/${selectedReaderId}/`, {
                checkpoint: selectedCheckpoint.id
            })
                .then(response => {
                    const updatedCheckpointSet = props.checkpoints.map(cp => {
                        // le checkpoint modifié
                        if (cp.id === selectedCheckpoint.id) {
                            return {
                                ...cp,
                                reader: response.data
                            };
                        }

                        // si un autre checkpoint avait ce reader → on le désassocie
                        if (cp.reader && cp.reader.id === response.data.id) {
                            return {
                                ...cp,
                                reader: null
                            };
                        }

                        return cp;
                    });

                    props.setCheckpoints(updatedCheckpointSet);
                    closeAssignModal();
                })
                .catch(err => console.log(err));
        }

        // CAS 2 : DÉSASSIGNATION
        else if (selectedCheckpoint?.reader) {
            axiosInstance.patch(`/readers/${selectedCheckpoint.reader.id}/`, {
                checkpoint: null
            })
                .then(response => {
                    const updatedCheckpointSet = props.checkpoints.map(cp => {
                        if (cp.id === selectedCheckpoint.id) {
                            return {
                                ...cp,
                                reader: null
                            };
                        }
                        return cp;
                    });

                    props.setCheckpoints(updatedCheckpointSet);
                    closeAssignModal();
                })
                .catch(err => console.log(err));
        }
    };


    const handleSubmitReader = (e) => {
        e.preventDefault();
        axiosInstance.patch(`/readers/${selectedReader.id}/`, selectedReader)
            .then(response => {
                const updatedCheckpointSet = [...props.checkpoints];
                const checkpoint = updatedCheckpointSet.findIndex(check => check.reader.id === response.data.id);
                updatedCheckpointSet[checkpoint].reader = response.data;
                props.setCheckpoints(updatedCheckpointSet);
                setFormErrors(null);
            })
            .catch(error => {
                setFormErrors(error?.response?.data);
            })
    }

    return (
        <div>
            <Row className="border-bottom">
                <Col sm={2}>Checkpoint</Col>
                <Col sm={2}>Lecteur</Col>
                <Col sm={1}>En ligne</Col>
                <Col sm={1}>Scanning</Col>
                <Col sm={1}>Mode</Col>
                <Col sm={1}>Power</Col>
                <Col sm={2}>Antennas</Col>
                <Col sm={1}></Col>
                <Col sm={1}></Col>
            </Row>
            {props.checkpoints && props.checkpoints.map((checkpoint, index) => (
                <Row key={index} className="border-bottom">
                    <Col sm={2} className="align-self-center">{checkpoint.name}</Col>
                    {checkpoint.reader ? (
                        <>
                            <Col sm={2} className="align-self-center"><Link onClick={() => openModal(index)}>{checkpoint.reader?.name}</Link></Col>
                            <Col sm={1} className="align-self-center">{checkpoint.reader.online ? "🟢" : "🔴"}</Col>
                            <Col sm={1} className="align-self-center">{checkpoint.reader.start_inventory ? "🟢" : "🔴"}</Col>
                            <Col sm={1} className="align-self-center">{checkpoint.reader.mode}</Col>
                            <Col sm={1} className="align-self-center">{checkpoint.reader.config_txpower}</Col>
                            <Col sm={2} className="align-self-center">{checkpoint.reader.config_antenna4 ? "🟢" : "🔴"} {checkpoint.reader.config_antenna3 ? "🟢" : "🔴"} {checkpoint.reader.config_antenna2 ? "🟢" : "🔴"} {checkpoint.reader.config_antenna1 ? "🟢" : "🔴"}</Col>
                            <Col sm={1} className="align-self-center">
                                {<Button
                                    onClick={() => props.handleScanningToggle(checkpoint.id, checkpoint.reader.start_inventory)}
                                    disabled={!checkpoint.reader.online}
                                >
                                    {checkpoint.reader.start_inventory ? "Stop" : "Start"}

                                </Button>
                                }</Col>
                        </>) : (<Col sm={11}>Lecteur non défini</Col>)}
                    <Col sm={1} className="align-self-center">
                        {checkpoint.reader ? (
                            <>
                                <Link onClick={() => openReaderConfigModal(index)}>
                                </Link>
                                {" "}
                                <Button size="sm" onClick={() => openAssignModal(index)}>
                                    Change
                                </Button>
                            </>
                        ) : (
                            <Button size="sm" onClick={() => openAssignModal(index)}>
                                Assign
                            </Button>
                        )}
                    </Col>
                </Row>
            ))
            }
            <ReaderModal
                showModal={showModal}
                closeModal={closeModal}
                selectedReader={selectedReader}
                formErrors={formErrors}
                handleChangeReader={handleChangeReader}
                handleSubmitReader={handleSubmitReader}
            />

            <Modal show={showAssignModal} onHide={closeAssignModal}>
                <Form onSubmit={handleAssignReader}>
                    <Modal.Header closeButton>
                        <Modal.Title>Assign Reader</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>Checkpoint</Form.Label>
                            <Form.Control value={selectedCheckpoint?.name || ""} disabled />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Reader</Form.Label>
                            <Form.Select
                                value={selectedReaderId}
                                onChange={(e) => setSelectedReaderId(e.target.value)}
                            >
                                <option value="">None</option>
                                {readers.map(reader => (
                                    <option key={reader.id} value={reader.id}>
                                        {reader.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeAssignModal}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>

    )
}

export default CheckpointInline;